const SAFE_SCHEME = /^https?:\/\//iu

/**
 * Resolve a cell's link target. v3 opens these through `window.open` after rewriting the scheme
 * (`OrphexTd.vue:goLink`): `http://` is upgraded to `https://` and a bare host gets `https://`
 * prefixed. That prefixing is also what keeps a hostile `javascript:` value inert, so it is kept
 * rather than replaced with a scheme allowlist.
 */
export function resolveCellLink(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const target = value.trim()
  if (target === '' || target === '-' || target === 'None') return null
  if (SAFE_SCHEME.test(target)) return target.replace(/^http:\/\//iu, 'https://')
  return `https://${target}`
}
